(function () {
  var cardSelector = '.product-card--second.product-grid';
  var firstTouchAttr = 'data-mnx-first-touch';

  function closeCards(exceptCard) {
    document.querySelectorAll(cardSelector + '.is-touch-revealed').forEach(function (card) {
      if (card !== exceptCard) {
        card.classList.remove('is-touch-revealed');
        card.removeAttribute(firstTouchAttr);
      }
    });
  }

  document.addEventListener('pointerdown', function (event) {
    if (event.pointerType === 'mouse') return;

    var card = event.target.closest(cardSelector);

    if (!card) {
      closeCards(null);
      return;
    }

    if (event.target.closest('.product-card__buttons')) return;

    if (!card.classList.contains('is-touch-revealed')) {
      closeCards(card);
      card.classList.add('is-touch-revealed');
      card.setAttribute(firstTouchAttr, '1');
    }
  }, { passive: true });

  document.addEventListener('pointercancel', function (event) {
    var card = event.target.closest && event.target.closest(cardSelector);
    if (card) card.removeAttribute(firstTouchAttr);
  }, { passive: true });

  document.addEventListener('click', function (event) {
    var card = event.target.closest(cardSelector);
    if (!card) return;
    if (event.target.closest('.product-card__buttons')) return;

    if (card.getAttribute(firstTouchAttr) === '1') {
      event.preventDefault();
      event.stopPropagation();
      card.removeAttribute(firstTouchAttr);
    }
  }, true);
})();
